import $ from 'jquery';
import Swiper from 'swiper';

export default class BannerSlideshow {
    constructor() {
        if($('.js-banner-slideshow').length) {
            const bannerSlideshow = new Swiper('.js-banner-slideshow', {
                autoplay: true,
                delay: 7000,
                loop: true,
                slidesPerView: 1
            });
        };
    };
};
